export interface SecondaryReasonNode {
    id: string | number;
    display?: string;
}

export interface ReasonNode {
    id: string | number;
    display?: string;
    secondaryReasons?: SecondaryReasonNode[] | null;
}

export interface FlagNode {
    id: string | number;
    display?: string;
    reasons?: ReasonNode[] | null;
}

export type FlagIndex = Map<
    string,
    { reasons: Set<string>; secondary: Set<string> }
>;

export function buildFlagIndex(tree: FlagNode[] | null | undefined): FlagIndex {
    const idx: FlagIndex = new Map();

    (tree ?? []).forEach((f) => {
        const rSet = new Set<string>();
        const sSet = new Set<string>();

        (f.reasons ?? []).forEach((r) => {
            rSet.add(String(r.id));
            (r.secondaryReasons ?? []).forEach((s) => sSet.add(String(s.id)));
        });

        idx.set(String(f.id), { reasons: rSet, secondary: sSet });
    });

    return idx;
}

/**
 * (Optional) Helper that returns arrays instead of Sets.
 * Converts the Map<flagId, {reasons: Set, secondary: Set}> produced by
 * `buildFlagIndex` into a plain object of arrays for easier consumption
 * (e.g., when serializing or sending in API requests).
 */
export function buildFlagIndexArrays(tree: FlagNode[] | null | undefined) {
    const map = buildFlagIndex(tree);
    return Array.from(map.entries()).reduce<Record<
        string,
        { reasons: string[]; secondary: string[] }
    >>((acc, [flagId, sets]) => {
        acc[flagId] = {
            reasons: Array.from(sets.reasons),
            secondary: Array.from(sets.secondary),
        };
        return acc;
    }, {});
}
